export function formatDateDDMMYYYYHHMM(date) {
    // Data original
    // Converter para objeto Date
    const data = new Date(date);

    // Obter componentes da data
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Os meses começam do zero
    const ano = data.getFullYear();
    const hora = String(data.getHours()).padStart(2, '0');
    const minuto = String(data.getMinutes()).padStart(2, '0');

    // Formatar data e hora
    return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
}

export function formatDateDDMMYYYY(date) {
    // Data original
    // Converter para objeto Date
    const data = new Date(date);

    // Obter componentes da data
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Os meses começam do zero
    const ano = data.getFullYear();

    // Formatar data e hora
    return `${dia}/${mes}/${ano}`;
}

export function formatPhone(number) {
    if (number === undefined) return;
    const clear_number = number.replace(/\D/g, '');
    if (number.length === 10) {
        return clear_number.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2 - $3');

    } else if (number.length === 11) {
        return clear_number.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3 - $4');

    } else {
        return number;
    }
}

export function formatCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.padStart(11, '0');
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
export function formatCNPJ(value) {
    // Verifica se o valor é válido
    const valid = this.validCNPJ(value);

    // Se o valor não for válido, retorna vazio
    if (!valid) return '';

    // Elimina tudo que não é dígito
    const numbers = this.matchNumbers(value);
    const text = numbers.join('');

    // Formatação do CNPJ: 99.999.999/9999-99
    const format = text.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
    );

    // Retorna o valor formatado
    return format;
}

export function formatBirth(dateStr) {
    const [ano, mes, dia] = dateStr.split('-');
    return `${dia}/${mes}/${ano}`;
}

export function formatCEP(cep) {
    if (cep === null || cep === undefined) return '';

    // Accept numbers too
    const raw = typeof cep === 'number' ? String(cep) : cep;

    // Keep only digits
    const digits = String(raw).replace(/\D/g, '');

    if (!digits) return '';

    // Use only first 8 digits (CEP has 8 digits)
    const trimmed = digits.slice(0, 8);

    // Format: 5 digits, optional hyphen + last up to 3 digits
    if (trimmed.length <= 5) return trimmed;
    return `${trimmed.slice(0, 5)}-${trimmed.slice(5)}`;
}

export function formatCurrency(val) {
    if (!val) return "";

    // Remove tudo que não for número
    const onlyNumbers = val.replace(/\D/g, "");

    // Divide por 100 para considerar centavos
    const numberValue = parseFloat(onlyNumbers) / 100;

    // Formata para BRL
    return numberValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
};

export function formatMoney(value){
  return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
}